const PREVIEW_PREFIX = 'kwc:pattern-admin:preview:v1';

function getImageUrl(image) {
  if (typeof image === 'string') return image;
  return image?.preview || image?.url || '';
}

export function buildPatternPreview(formData, images, mainImage) {
  const previewImages = images.map(getImageUrl).filter(Boolean);

  return {
    ...formData,
    status: formData.status === 'published' ? 'published' : 'draft',
    images: previewImages,
    main_image: getImageUrl(mainImage) || previewImages[0] || '',
  };
}

export function savePatternPreview(storage, pattern) {
  if (!storage) return null;

  try {
    const id = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    const key = `${PREVIEW_PREFIX}:${id}`;
    storage.setItem(key, JSON.stringify({ version: 1, pattern }));
    return key;
  } catch {
    return null;
  }
}

export function loadPatternPreview(storage, key) {
  if (!key?.startsWith(`${PREVIEW_PREFIX}:`)) return null;

  try {
    const value = storage?.getItem(key);
    if (!value) return null;

    const preview = JSON.parse(value);
    if (preview?.version !== 1 || !preview.pattern || typeof preview.pattern !== 'object') {
      return null;
    }

    return preview.pattern;
  } catch {
    return null;
  }
}
